var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleBrokenBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11304_34040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 9.23745V10.0041C18.3336 11.8011 17.7517 13.5497 16.6757 14.989C15.5998 16.4283 14.0874 17.4812 12.3641 17.9907C10.6408 18.5002 8.79902 18.439 7.11336 17.8163C5.4277 17.1935 3.98851 16.0425 3.01044 14.535C2.03236 13.0275 1.56779 11.2442 1.68603 9.45105C1.80427 7.65792 2.49897 5.95106 3.66654 4.58501C4.8341 3.21897 6.41196 2.26694 8.16479 1.87091C9.91763 1.47488 11.7515 1.65607 13.393 2.38745M18.3346 3.33268L10.0013 11.6743L7.5013 9.17435",
    stroke: "#377DFF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11304_34040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleBrokenBlue);
export default __webpack_public_path__ + "static/media/check-circle-broken-blue.d8422f432a20452e7ec05f6ed954de85.svg";
export { ForwardRef as ReactComponent };